module.exports = " <footer class=mdl-mini-footer> <div class=mdl-mini-footer__left-section> <div class=mdl-logo>{{'general.application.title' | label}}</div> <ul class=mdl-mini-footer__link-list> <li><a href=#>{{'footer.link.help' | label}}</a></li> <li><a href=#>{{'footer.link.terms.conditions' | label}}</a></li> </ul> </div> </footer> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/admin/components/Footer.vue
// module id = 278
// module chunks = 0